import { forwardRef, type InputHTMLAttributes, type SelectHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

// Inputs sit on a `bg-card` surface (modals, settings). Using bg-bg4 + border-border2
// keeps them clearly delineated as a "well" in BOTH dark and light themes (fixes the
// previously near-invisible add-member fields, where bg-bg3 ≈ bg-card).
const controlClass =
  "w-full h-9 rounded-sm border border-border2 bg-bg4 px-3 text-sm text-text outline-none transition-all placeholder:text-text3 focus:border-primary focus:bg-bg3 disabled:cursor-not-allowed disabled:opacity-55";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => (
  <input ref={ref} className={cn(controlClass, className)} {...props} />
));
Input.displayName = "Input";

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(({ className, children, ...props }, ref) => (
  <select ref={ref} className={cn(controlClass, className)} {...props}>
    {children}
  </select>
));
Select.displayName = "Select";

export const formControlClass = controlClass;
